import styled from 'styled-components';
import { Box, TextField } from '@mui/material';

// ثابت‌ها برای رنگ‌ها و فونت
const COLORS = {
  white: '#FFFFFF',
  gray: '#D9D9DD',
  darkGray: '#35373C',
  lightGray: '#BBC0CB',
  blue: '#0066CC',
  secondaryGray: '#60646E',
  titleGray: '#A6AAB5',
  darkTitle: '#25282E',
  error: 'red',
};

const FONT = {
  family: 'IRANYekanXFaNum',
  weights: {
    regular: 500,
    bold: 700,
    extraBold: 900,
  },
};

// کانتینر اصلی
export const SBox = styled(Box)`
    background-color: ${COLORS.white};
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 360px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: auto;
    @media (max-width: 768px) {
        max-width: 350px;
    }
`;

export const Form = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    @media (max-width: 768px) {
        max-width: 350px;
    }
`;

// استایل‌های فرم
export const TextFieldWrapper = styled.div`
    width: 100%;
    /* min-height keeps the 48px field box, but lets the wrapper grow so the
       helper text below the input stays inside it instead of overlapping. */
    min-height: 48px;
    position: relative;
    margin-bottom: 14px;
`;

export const TextFieldBackground = styled.div`
    width: 100%;
    height: 48px;
    position: absolute;
    border-radius: 8px;
    border: 1px solid ${COLORS.gray};
`;

export const STextField = styled(TextField)`
    width: 100%;
    border-radius: 8px;
    margin: 0;
    /* The 48px belongs to the input box, not the whole field: the TextField
       also contains the helper text, so fixing its height clips the error. */
    .MuiOutlinedInput-root {
        height: 48px;
        input {
            color: ${COLORS.lightGray};
            font-family: ${FONT.family};
            font-size: 14px;
            font-weight: ${FONT.weights.bold};
        }
        fieldset {
            border: none;
        }
        input::placeholder {
            color: ${COLORS.lightGray};
            font-family: ${FONT.family};
            font-size: 14px;
            font-weight: ${FONT.weights.bold};
        }
    }
    /* MUI wraps helperText in a <p> that is LTR and left-indented by default */
    .MuiFormHelperText-root {
        direction: rtl;
        text-align: right;
        margin: 4px 0 0 0;
    }
`;

export const CustomHelperText = styled.span<{ error: boolean }>`
  color: ${({ error }) => (error ? '#d32f2f' : '#757575')};
  font-size: 12px;
  font-family: 'IRANYekanXFaNum';
  /* direction (not just text-align) so Persian punctuation sits on the left end */
  direction: rtl;
  text-align: right;
  display: block;
`;

// استایل‌های متنی
export const Label = styled.label`
    color: ${COLORS.darkGray};
    font-size: 14px;
    font-family: ${FONT.family};
    font-weight: ${FONT.weights.regular};
    text-align: right;
    margin: 2px 0 1px 30px;
    @media (max-width: 768px) {
        margin: 2px 0 1px 12px;
    }
`;

export const LableInputMobile = styled(Label)`
    margin: 2px 0 14px 1px;
`;

export const Title = styled.div`
    color: ${COLORS.titleGray};
    font-size: 14px;
    font-family: ${FONT.family};
    font-weight: ${FONT.weights.extraBold};
    margin: 2px 0 12px 30px;
`;

export const TitlePhone = styled.h3`
    margin: 2px 0 1px 12px;
    color: ${COLORS.darkTitle};
    font-size: 20px;
    font-family: ${FONT.family};
    font-weight: ${FONT.weights.extraBold};
`;

// استایل‌های لینک و دکمه
export const LinkContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 1px;
`;

export const ClickableText = styled.span`
    cursor: pointer;
    color: ${COLORS.secondaryGray};
    font-size: 12px;
    font-family: ${FONT.family};
    font-weight: ${FONT.weights.regular};
    &:hover {
        text-decoration: underline;
    }
`;

export const ClickableTextBlue = styled(ClickableText)`
    color: ${COLORS.blue};
`;

/** Same look as ClickableText but inert — a label, not a control. */
export const StaticText = styled.span`
    color: ${COLORS.secondaryGray};
    font-size: 12px;
    font-family: ${FONT.family};
    font-weight: ${FONT.weights.regular};
`;

export const ClickableTextRegister = styled(ClickableText)`
    color: ${COLORS.blue};
    font-size: 14px;
    font-weight: ${FONT.weights.bold};
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
`;

// استایل‌های خطا
export const ErrorMessage = styled.div`
    color: ${COLORS.error};
    font-size: 12px;
    font-family: ${FONT.family};
    direction: rtl;
    text-align: right;
    width: 100%;
    margin-top: 10px;
`;

export const Divider = styled.hr`
    width: 100%;
    border: 1px dotted ${COLORS.gray};
    margin: 2px 0 20px 20px;
`;

// استایل‌های مودال
export const ModalContent = styled(Box)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${COLORS.white};
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 24px;
    width: 100%;
    max-width: 350px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-family: ${FONT.family};
`;

export const ModalTitle = styled.div`
    color: ${COLORS.darkTitle};
    font-size: 18px;
    font-family: ${FONT.family};
    font-weight: ${FONT.weights.bold};
    margin-bottom: 16px;
    text-align: right;
    width: 100%;
`;

export const ModalItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 12px;
    direction: rtl; /* راست‌چین کردن محتوا */
    & > ${Label} {
        flex-shrink: 0;
        margin-left: 16px; /* فاصله بین لیبل و لینک */
    }
    & > a {
        text-align: left; /* لینک‌ها چپ‌چین */
    }
`;
